import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURES]: {
		url:'/company/:companyId/done_works/:doneWorkId/measures/'
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_PREVIEW]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/preview/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE_POPUP]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/popup/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].GET_DONE_WORKS_MEASURE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/',
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].CREATE_DONE_WORKS_MEASURE]: {
		url:'/company/:companyId/done_works/:doneWorkId/measures/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PATCH_DONE_WORKS_MEASURE_BULK_UPDATE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/bulk_update/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].POST_DONE_WORKS_MEASURE_BULK_CREATE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/bulk_create/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].PUT_DONE_WORKS_MEASURE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.DONE_WORKS_MEASURES].DELETE_DONE_WORKS_MEASURE]: {
		url: '/company/:companyId/done_works/:doneWorkId/measures/:measureId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}